import * as React from "react";

export default function Logo({ maxWidth }: { maxWidth: number }) {
  return (
    <img
      src="/logo-mint-green.svg"
      alt="logo"
      style={{ maxWidth: `${maxWidth}px`, height: "auto" }}
    />
  );
}
